import { Component, Input, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { QuestionBase } from './question-base';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-question',
  templateUrl: './dynamic-form-question.component.html',
  styleUrls: ['./dynamic-form-question.component.scss']
})
export class DynamicFormQuestionComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() question: QuestionBase<any>;
  @Input() form: FormGroup<any>;
  @Input() textareaTip: string;
  private changeSubscription: Subscription;
  public currentClasses: any;
  passwordClear = false;
  @Input() formError: any;
  constructor(private translate: TranslateService) {}

  public ngOnInit(): void {
    this.question.form = this.form;
    const required = this.question.validators && this.question.validators.required;
    this.currentClasses = {
      required: required,
      validate: true,
      form__group: this.question.isFormGroup
    };
  }

  get isValid() {
    if (this.question.key) {
      return (
        this.form.controls[this.question.key].valid ||
        !this.form.controls[this.question.key].touched
      );
    }
    return true;
  }

  get errors() {
    const errors = this.question.key ? this.form.controls[this.question.key].errors : [];
    const messages = [];
    if (errors) {
      Object.keys(errors).forEach((error) =>
        messages.push({ message: 'error.' + error, params: errors[error] })
      );
    }
    return messages;
  }

  public ngAfterViewInit(): void {
    if (
      this.question.key &&
      this.question.eventHandlers.change &&
      this.question.controlType !== 'group'
    ) {
      this.changeSubscription = this.form.controls[this.question.key].valueChanges.subscribe(
        (val) => {
          this.question.value = typeof val === 'string' ? val.trim() : val;
          setTimeout(() => this.question.eventHandlers.change(val));
        }
      );
    }
  }

  updateChildQuestions(data) {
    if (this.question.childQuestions && this.question.childQuestions.length) {
      this.question.childQuestions.forEach((childQuestion) => {
        if (childQuestion.key) {
          const control = this.form.controls[childQuestion.key];
          if (data && data[childQuestion.source]) {
            control.reset(data[childQuestion.source]);
            control.markAsDirty();
          } else {
            control.reset();
          }
          control.markAsDirty();
        }
      });
    }
    if (this.question.eventHandlers && this.question.eventHandlers.change) {
      this.question.eventHandlers.change(data);
    }
  }

  public ngOnDestroy(): void {
    if (this.changeSubscription) {
      this.changeSubscription.unsubscribe();
    }
  }
}
